import React, { Component } from 'react';
import { Banner } from '../../Components'
import './Listing.scss'
import {Helmet} from "react-helmet"

import { Link } from 'react-router-dom'
import { observer, inject } from 'mobx-react'
@inject("store")
@observer  
class Listing extends Component {
	render() {
		return (
			<div className="listing-page">
				<Helmet>
					<title>Listing | GPbook</title>
				</Helmet>	
				<Banner title="Listing" subtitle="Are you looking to be listed or update your details in the directory?" />

				<div className="container page">
					
					<h4 className="m-b-1 text-center">Please select one of the following options: </h4>
					
					<div className="row">
						<div className="col-md-3"></div>	
						<div className="col-md-3">
							<a href="https://online.gpbook.com.au/update" to="/listing/update" className="option">
								<div className="holder">
									<div className="image">		
										<img src={require('./update-listing.svg')} alt="New Listing" />
									</div>		
									<div className="text">
										<h3><span>Update</span> Listing</h3>
										<p>Existing listing can login to update details.</p>
									</div>
								</div>
							</a>
						</div>
						<div className="col-md-3">
							<a href="https://online.gpbook.com.au/update" to="/listing/new" className="option">
								<div className="holder">
									<div className="image">
										<img src={require('./new-listing.svg')} alt="New Listing" />	
									</div>	 
									<div className="text">
										<h3><b>New</b> Listing</h3>
										<p>Listings are <u>free</u>. Fill out our form to get listed.</p>
									</div>
								</div>
							</a>
						</div>
						
					</div>
				</div>
			</div>
		);
	}
}

export default Listing;


// WEBPACK FOOTER //
// ./src/Containers/Listing/Listing.js